import * as React from 'react';
import * as Cx from 'classnames';
import { Link, Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import {
  accommodations,
  groupedAccommodations,
  AccommodationData,
  AccommodationsGroup,
  AccommodationGroupData,
} from '../data/accommodations';

import './accommodations.css';

const accommodationsBackground = {
  backgroundImage: `url(${process.env.PUBLIC_URL + '/img/accommodations_background.jpg'})`,
};

export default class AccommodationsPage extends React.PureComponent<RouteComponentProps<{}>, {}> {
  accommodationsMenuGroup = ({ location, accommodations: accs }: AccommodationsGroup): JSX.Element[] => {
    return [
      <p key={`${location}-label`} className="menu-label">
        {location}
      </p>,
      <ul key={`${location}-list`} className="menu-list">
        {accs.map(this.accommodationsMenuEntry)}
      </ul>,
    ];
  };

  accommodationsMenuEntry = ({ path, name }: AccommodationGroupData): JSX.Element => {
    return (
      <li key={path}>
        <Link
          to={path}
          className={Cx({
            'is-active': this.props.location.pathname === path,
          })}
        >
          {name}
        </Link>
      </li>
    );
  };

  accommodationsButtons = ({ location, accommodations: accs }: AccommodationsGroup): JSX.Element[] => {
    return accs.map(({ path, name }) => (
      <Link
        key={path}
        className={Cx({
          button: true,
          'is-active': this.props.location.pathname === path,
        })}
        to={path}
      >
        {name}
      </Link>
    ));
  };

  hotelDetails(acc: AccommodationData): JSX.Element {
    return (
      <div className="content">
        <h2 className="title is-4">{acc.name}</h2>
        <h3 className="subtitle is-6">
          <a href={acc.mapUrl} target="_blank" rel="noopener">
            {acc.address}
          </a>
        </h3>
        <table>
          <tbody>
            <tr>
              <th>Room rate</th>
              <td>{acc.roomRate}</td>
            </tr>
            <tr>
              <th>Promo code</th>
              <td>{acc.promoCode}</td>
            </tr>
            <tr>
              <th>Distance to venue</th>
              <td>{`${acc.travelTime} minutes`}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={2}>
                <a href={acc.url} target="_blank" rel="noopener">
                  Hotel website
                </a>
              </td>
            </tr>
          </tfoot>
        </table>
        <p>{acc.description}</p>
      </div>
    );
  }

  rentalDetails(acc: AccommodationData): JSX.Element {
    return (
      <div className="content">
        <h2 className="title is-4">{acc.name}</h2>
        <h3 className="subtitle is-6">
          <a href={acc.url} target="_blank" rel="noopener">
            Click here to see available properties
          </a>
        </h3>
        <p>{acc.description}</p>
      </div>
    );
  }

  accommodationInfo(acc: AccommodationData): () => JSX.Element {
    return () => (
      <section className="media">
        <div className="media-content">{acc.roomRate ? this.hotelDetails(acc) : this.rentalDetails(acc)}</div>
        <figure className="media-right is-hidden-mobile">
          <p className="image is-256x256">
            <img src={`${process.env.PUBLIC_URL}${acc.imgPath}`} />
          </p>
        </figure>
      </section>
    );
  }

  get accommodationRoutes(): JSX.Element[] {
    return accommodations.map(acc => <Route key={acc.path} path={acc.path} render={this.accommodationInfo(acc)} />);
  }

  render(): JSX.Element {
    return (
      <section className="section accommodations background escape-nav" style={accommodationsBackground}>
        <div className="container">
          <h1 className="title is-shadowed has-text-centered">Accommodations</h1>
          <div className="columns">
            <aside className="menu column is-2 is-hidden-mobile">
              {groupedAccommodations.map(this.accommodationsMenuGroup)}
            </aside>
            <aside className="column is-hidden-tablet">
              <div className="buttons">{groupedAccommodations.map(this.accommodationsButtons)}</div>
            </aside>
            <section className="column is-offset-1">
              <Switch>
                {this.accommodationRoutes}
                <Redirect to="/accommodations/turtlebay" />
              </Switch>
            </section>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/accommodations.tsx